import { ReactNode } from 'react'
import classnames from 'classnames'

import ShopMainSidebar from '../ShopMainSidebar'
import GridContainer from 'modules/marketplace/layout/components/GridContainer'
import { Container } from 'modules/marketplace/layout/components/ResponsiveContainers'

import { ElasticsearchIndexEnum } from '../../../../../../__generated__/globalTypes'

import styles from './ShopMainContainer.module.css'

type ShopMainContainerProps = {
  className?: string
  classNameMainContainer?: string
  children?: ReactNode
  productCategoryMode?: ElasticsearchIndexEnum[]
}

const ShopMainContainer = ({
  className,
  classNameMainContainer,
  children,
  productCategoryMode
}: ShopMainContainerProps) => {
  return (
    <Container className={className}>
      <GridContainer>
        <ShopMainSidebar className={styles.sideBarContainer} productCategoryMode={productCategoryMode} />
        <div className={classnames(styles.mainContainer, classNameMainContainer)}>{children && children}</div>
      </GridContainer>
    </Container>
  )
}

export default ShopMainContainer
